export const domainKeys = {
  all: ["domains"] as const,
  lists: () => ["domains", "list"] as const,
  list: (params: { page: number; perPage: number; q: string }) =>
    ["domains", "list", params] as const,
  detail: (id: string | number) => ["domains", "detail", String(id)],
  dns: (id: string | number) => ["domains", "dns", String(id)],
  sites: (id: string | number) => ["domains", String(id), "sites"],
};
